/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type {ConcreteFragment} from 'relay-runtime';
export type SbSharedRelatedItems_user = {|
  +isVerifiedTrade: ?boolean;
|};
*/


const fragment /*: ConcreteFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SbSharedRelatedItems_user",
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "args": null,
      "name": "isVerifiedTrade",
      "storageKey": null
    },
    {
      "kind": "FragmentSpread",
      "name": "SbSharedItemTile_user",
      "args": null
    }
  ],
  "type": "User"
};

module.exports = fragment;
